import { isValidPosthogEnvironment } from "@/utils/posthog-utils/posthog";
import { useFeatureFlagEnabled, useFeatureFlagPayload } from "posthog-js/react";
import { useEnvironment } from "@/hooks/use-environment/useEnvironment";

export const useConditionalFeatureFlagPayload = (
  featureFlagKey,
  options = { testPayload: false }
) => {
  const { isProduction } = useEnvironment();
  const { testPayload } = options;
  const enabled = useFeatureFlagEnabled(featureFlagKey);
  const payload = useFeatureFlagPayload(featureFlagKey);
  if (testPayload && !isProduction) {
    return testPayload;
  }
  if (isValidPosthogEnvironment() && enabled) return payload;
  return false;
};
